// extracted by mini-css-extract-plugin
export default {"tooltip":"Un-z","sharingV2":"Vn-z","sharingIconsV2":"Wn-z","links":"Xn-z","link":"Yn-z","facebookV2":"Zn-z","twitterV2":"_n-z","pinterestV2":"ao-z"};